import React, { useState } from "react";
import _ from "lodash";

import type { NormalisedProduct } from "@app/scripts/types";
import { sortedVariants, sortVariants, stripColourFromVariantTitle } from "@app/scripts/utils";

type Props = {
  variants: NormalisedProduct["variants"];
  handleChangeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultTitle?: string;
  selectedId?: string | number;
  lineItemKey?: string | number;
};

export const ProductSizeSelect: React.FC<Props> = ({
  variants,
  handleChangeVariant,
  defaultTitle = "Select size",
  selectedId,
}) => {
  const [defaultVisible, setDefaultVisible] = useState(true);

  const changeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void = (e) => {
    if (e.target.value !== "__default") {
      setDefaultVisible(false);
      handleChangeVariant(e);
    }
  };

  // Sorting variants to display correct order when nested
  const sortedVariants = sortVariants(variants)

  return sortedVariants && sortedVariants.length > 1 ? (
    <div className="product__variant-picker _field _field__select">
      <select className="select__select" name="Size" onChange={changeVariant} defaultValue={selectedId}>
        {!selectedId && defaultVisible && <option value="__default">{defaultTitle}</option>}
        {sortedVariants?.map((variant) => (
          <option key={variant.id} value={variant.id} disabled={variant.currentlyNotInStock === true}>
            {stripColourFromVariantTitle(variant.title)}
          </option>
        ))}
      </select>
    </div>
  ) : null;
};
